(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sticky-footer"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener("DOMContentLoaded", function() {

    var stickyBtn = document.querySelector('.sticky-btn');
    var productForm = document.querySelector('#AddToCart');
    var stickyAddToCartBtn = document.querySelector('#StickyAddToCart');

    stickyBtn?.addEventListener?.('click', function() {
      console.log('sticky-btn clicked');
      // Simulate a click on the StickyAddToCart button
      if (stickyAddToCartBtn) {
        stickyAddToCartBtn.click();
      } else {
        console.error('Button with ID StickyAddToCart not found');
      }
    });

  });

  } catch(e) { console.error(e); }
})();
})();
